import { initialPagination, initialState, makeListEffects, makeListReducers } from '@/models/utils';

const namespace = 'areas';

const AreaModel = {
  namespace,
  state: initialState,
  effects: makeListEffects({
    namespace,
    fetchRoute: 'area',
    fetchParams: 'NameDescriptionIsActive',
  }),
  reducers: makeListReducers({
    initialPagination,
    initialState,
  }),
};

export default AreaModel;
